import InjectionTestCaseRequested from '@/pages/injection/InjectionTestCaseRequested.vue'

export default [
  {
    path: '/testCaseRequested',
    component: InjectionTestCaseRequested
  }
]
